<template>
  <div class="matrix questionWrap">
    <MatrixPage v-if="currentAnswerConfig.isSingleAnswer"></MatrixPage>
    <MatrixAll v-else></MatrixAll>
  </div>
</template>

<script lang="ts" setup>
import answerHook from "@/hooks/answerHook";
import MatrixPage from "@/components/matrix/MatrixSinglePage.vue";
import MatrixAll from "@/components/matrix/MatrixSingleAll.vue";
const { currentAnswerConfig } = answerHook();
</script>
